import { useNavigate } from 'react-router-dom';
import { siteInfo } from '@/mocks/anime';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20anime%20style%20cityscape%20at%20sunset%20with%20warm%20golden%20orange%20and%20crimson%20sky%2C%20silhouettes%20of%20buildings%20and%20floating%20cherry%20blossom%20petals%2C%20atmospheric%20cinematic%20lighting%2C%20beautiful%20gradient%20sky%2C%20anime%20background%20art%20with%20clean%20simple%20composition&width=1800&height=1200&seq=hero-bg-01&orientation=landscape"
          alt="天天动漫 - 每天追番看动漫"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          让每一天都与动漫相伴
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="/category/recent"
            onClick={(e) => { e.preventDefault(); navigate('/category/recent'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即追番
            <span className="w-4 h-4 inline-flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
          <a
            href="/about"
            onClick={(e) => { e.preventDefault(); navigate('/about'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-base font-medium hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer border border-white/30"
          >
            了解更多
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}